module.exports = __webpack_public_path__ + "rails.40a636.svg";